import { render, staticRenderFns } from "./commentModal.vue?vue&type=template&id=3c55b92a&scoped=true"
import script from "./commentModal.vue?vue&type=script&lang=js"
export * from "./commentModal.vue?vue&type=script&lang=js"
import style0 from "./commentModal.vue?vue&type=style&index=0&id=3c55b92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55b92a",
  null
  
)

export default component.exports